import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import Moment from 'moment';
import Input from '../../components/new-ui/input_field';
import Dropdown from '../../forecast-app/shared/components/dropdowns/dropdown';
import ImportHolidayCalendarEntriesMutation from '../../mutations/import_holiday_calendar_entries_mutation';
import Util from '../../forecast-app/shared/util/util';
import 'whatwg-fetch'; //IE 11 fetch polyfill
import GenericModal from './generic_modal';
import {BUTTON_COLOR, BUTTON_STYLE} from '../../constants';
import CountryData from '../../holiday_api_countries.json';

class ImportHolidayCalendarEntriesModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			year: Moment().year(),
			selectedCountry: 'US',
			canImport: true,
			validYear: true
		};
		this.countryOptions = CountryData.countries
			.map(el => {
				return {value: el.code, label: el.name};
			})
			.sort((a, b) => {
				if (a.label > b.label) return 1;
				if (a.label < b.label) return -1;
				return 0;
			});
	}

	onYearChange(year) {
		const currentYear = Moment().year();
		const validYear = year >= currentYear - 100 &&  year <= currentYear + 100;
		this.setState({
			year,
			validYear
		});
	}

	onCountryChange(option) {
		this.setState({selectedCountry: option.value});
	}

	importHolidayCalendarEntries() {
		this.setState({canImport: false});
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		const init = {headers: headers, credentials: 'include'};
		fetch(process.env.GRAPHQL_ENDPOINT.slice(0, -7) + 'import-holiday-calendar?year=' + this.state.year + '&country=' + this.state.selectedCountry, init)
			.then(result => result.json())
			.then(json => {
				const jsonArray = Object.values(json)
					.map(h => h[0])
					.filter(h => h !== undefined);
				const holidayCalendarEntries = [];
				for (const holidayEntry of jsonArray) {
					const {date, name} = holidayEntry;

					holidayCalendarEntries.push({
						name,
						year: parseInt(date.substr(0, 4), 10),
						month: parseInt(date.substr(5, 7), 10),
						day: parseInt(date.substr(8, 10), 10),
					});
				}
				Util.CommitMutation(
					ImportHolidayCalendarEntriesMutation,
					{
						id: this.props.holidayCalendarId,
						holidayCalendarEntries,
					},
					() => {
						this.props.closeModal();
					},
					true,
					false
				);
			});
	}

	render() {
		const {formatMessage} = this.props.intl;
		const content = (
			<div className="import-holiday-calendar-entries-modal-content">
				<Input id="import-holidays-modal-year-input" label={formatMessage({id: 'settings_holiday_calendars.year'})} value={this.state.year} onChange={this.onYearChange.bind(this)} type="number" invalidInput={!this.state.validYear} placeholder="" />
				<Dropdown options={this.countryOptions} onChange={this.onCountryChange.bind(this)} value={this.state.selectedCountry} label={formatMessage({id: 'company_details.country_label'})} />
			</div>
		);

		return (
			<GenericModal
				closeModal={this.props.closeModal}
				buttons={[
					{
						text: this.props.cancelText || formatMessage({id: 'common.cancel'}),
						style: BUTTON_STYLE.FILLED,
						color: BUTTON_COLOR.WHITE,
					},
					{
						text: formatMessage({id: 'settings_holiday_calendars.import'}),
						style: BUTTON_STYLE.FILLED,
						color: BUTTON_COLOR.GREEN,
						callback: this.importHolidayCalendarEntries.bind(this),
						disabled: !this.state.canImport || !this.state.validYear,
						cy: 'import-public-holidays-button-modal',
					},
				]}
				headerText={formatMessage({id: 'settings_holiday_calendars.import'})}
				content={content}
			/>
		);
	}
}
ImportHolidayCalendarEntriesModal.propTypes = {
	closeModal: PropTypes.func.isRequired,
	holidayCalendarId: PropTypes.string.isRequired,
};
export default injectIntl(ImportHolidayCalendarEntriesModal);
